import { useState, useEffect } from 'react';
import axios from 'axios';
import confetti from 'canvas-confetti';
import { Trophy } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const formatCurrency = (value) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value || 0);

const fireConfetti = () => {
  const duration = 4000;
  const end = Date.now() + duration;
  confetti({ particleCount: 150, spread: 100, origin: { y: 0.6 }, zIndex: 10000 });
  const interval = setInterval(() => {
    if (Date.now() > end) { clearInterval(interval); return; }
    confetti({ particleCount: 40, angle: 60, spread: 60, origin: { x: 0 }, zIndex: 10000 });
    confetti({ particleCount: 40, angle: 120, spread: 60, origin: { x: 1 }, zIndex: 10000 });
  }, 400);
};

// Verifica o progresso e dispara a comemoração (1x por dia por dispositivo)
export const checkAndCelebrateDailyGoal = async () => {
  try {
    const res = await axios.get(`${API_URL}/api/dashboard/goals/progress`);
    const p = res.data;
    if (!p?.has_goal || p.daily_pct < 100) return;
    const key = `goal-celebrated-${new Date().toLocaleDateString('pt-BR')}`;
    if (localStorage.getItem(key)) return;
    localStorage.setItem(key, '1');
    window.dispatchEvent(new CustomEvent('daily-goal-reached', {
      detail: { today_total: p.today_total, daily_goal: p.daily_goal }
    }));
  } catch (e) { /* silencioso */ }
};

export const GoalCelebration = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      setData(e.detail);
      fireConfetti();
      setTimeout(() => setData(null), 8000);
    };
    window.addEventListener('daily-goal-reached', handler);
    return () => window.removeEventListener('daily-goal-reached', handler);
  }, []);

  if (!data) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 animate-fadeIn"
      onClick={() => setData(null)}
      data-testid="goal-celebration-overlay"
    >
      <div className="bg-white rounded-2xl shadow-2xl p-8 mx-4 max-w-sm text-center space-y-4 border-4 border-emerald-400">
        <div className="mx-auto w-20 h-20 rounded-full bg-emerald-100 flex items-center justify-center">
          <Trophy size={40} className="text-emerald-600" />
        </div>
        <h2 className="text-2xl font-bold text-emerald-600">🎉 META DIÁRIA BATIDA!</h2>
        <p className="text-slate-600">
          Vendido hoje: <strong className="text-slate-800">{formatCurrency(data.today_total)}</strong>
          <br />
          Meta do dia: {formatCurrency(data.daily_goal)}
        </p>
        <p className="text-sm text-emerald-700 font-medium">Parabéns pelo excelente trabalho! 💪</p>
        <button
          className="w-full py-2 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white font-medium transition-colors"
          onClick={() => setData(null)}
          data-testid="close-celebration-btn"
        >
          Continuar vendendo
        </button>
      </div>
    </div>
  );
};
